import React from "react";
import { motion } from "framer-motion";

const PolicyLayout = ({ title, children }) => {
  return (
    <div className="bg-white min-h-screen pt-10 pb-20">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-black text-gray-dark mb-8 tracking-tight">
            {title}
          </h1>
          <div className="prose prose-orange max-w-none text-gray-600 leading-relaxed space-y-6 font-medium">
            {children}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

const PrivacyPolicy = () => {
  return (
    <PolicyLayout title="Privacy Policy">
      <p>Last updated: April 24, 2026</p>
      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">1. Information Collection</h2>
        <p>At Khajuraho Routes, we collect information necessary to provide you with a seamless travel experience. This includes your name, contact number, email address, and travel preferences when you book a tour or submit an enquiry for Khajuraho packages.</p>
      </section>
      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">2. Use of Information</h2>
        <p>Your information is used solely for booking hotels, arranging transport, and securing monument permits in Khajuraho. We also use your contact details to share tour itineraries and updates regarding your trip.</p>
      </section>
      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">3. Data Security</h2>
        <p>We implement strict security measures to protect your personal data. We do not sell or share your personal information with third-party marketing companies. Access to your data is limited to authorized employees who need it to execute your travel plan.</p>
      </section>
      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">4. Cookies</h2>
        <p>Our website uses cookies to enhance user experience and analyze traffic patterns. You can choose to disable cookies in your browser settings, though this may affect the functionality of some parts of our site.</p>
      </section>
    </PolicyLayout>
  );
};

export default PrivacyPolicy;
